var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"data-atual"},[_c('b-col',{staticClass:"text-right"},[_vm._v(" Belo Horizonte, "+_vm._s(_vm.dataAtual)+". ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }